import { useContext, useEffect, useState } from "react";
import TagsList from "../../../components/commons/Tags/List";
import classes from "./index.module.scss";
import CardsList from "./CardsList";
import { FetchContext } from "../../../context/FetchContext";
import { getFilters } from "../../../helpers/getFilters";
import loaderClasses from "../../../components/commons/Loader.module.scss";

export default function Content() {
  const {
    store: {
      events,
      events: {
        queries: {
          upcoming: upcomingQuery,
          onDemand: onDemandQuery,
          tags: tagsQuery,
        },
        filters: { activeTags },
        onDemand: { hasMore, loading: onDemandLoading },
        upcoming: { loading: upcomingLoading },
        tags: { loading: tagsLoading },
      },
    },
    getItem,
    toggleActiveTag,
    checkIsTagActive,
    resetTags,
    setFilterQuery,
    setPageQuery,
  } = useContext(FetchContext);

  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const incrementPage = () =>
    setPage((prev) => {
      return prev + 1;
    });

  const getTags = getFilters(1);

  useEffect(() => {
    onDemandLoading || upcomingLoading || tagsLoading
      ? setLoading(true)
      : setLoading(false);
  }, [onDemandLoading, tagsLoading, upcomingLoading]);

  useEffect(() => {
    getItem({
      cb: getTags,
      propName: "tags",
      entity: "events",
      query: tagsQuery,
    });
  }, [JSON.stringify(tagsQuery)]);

  useEffect(() => {
    getItem({
      propName: "upcoming",
      entity: "events",
      query: upcomingQuery,
    });
  }, [JSON.stringify(upcomingQuery)]);

  useEffect(() => {
    getItem({
      propName: "onDemand",
      entity: "events",
      query: onDemandQuery,
    });
  }, [JSON.stringify(onDemandQuery)]);

  useEffect(() => {
    setFilterQuery(activeTags, "events", "onDemand");
    setFilterQuery(activeTags, "events", "upcoming");
  }, [activeTags, setFilterQuery]);

  useEffect(() => {
    setPageQuery("events", "onDemand", page);
    return () => {
      setPageQuery("events", "onDemand", 1);
    };
  }, [page, setPageQuery]);

  return (
    <section className={classes.section}>
      {loading ? <div className={loaderClasses.loader} /> : null}
      <div className={classes.container}>
        <div className={classes.body}>
          <div className={classes.header}>
            <TagsList
              toggleActiveTag={toggleActiveTag}
              checkIsTagActive={checkIsTagActive}
              getItem={getItem}
              tags={events?.tags}
              setPage={setPage}
              resetTags={resetTags}
              activeTags={activeTags}
              entity="events"
            />
          </div>
          <CardsList title={"Upcoming"} cards={events?.upcoming} />
          <CardsList title={"On Demand"} cards={events?.onDemand} />
        </div>
        {hasMore ? (
          <button
            disabled={onDemandLoading}
            className={classes["load-more"]}
            onClick={() => {
              incrementPage(page);
            }}
          >
            SHOW MORE EVENTS
          </button>
        ) : null}
      </div>
    </section>
  );
}
